/**
 * Navigation utilities for cases where React Router's useNavigate() cannot be used,
 * such as class components or non-React contexts (e.g., after account deletion,
 * session expiry, or critical auth failures that require a full page reload).
 */

/**
 * Performs a hard browser navigation to the given path, bypassing the SPA router.
 * Use this only when a full page reload is intentional (e.g., logout, session expiry).
 */
export function forceNavigate(path: string): void {
	window.location.href = path;
}

/**
 * Opens an external link or protocol handler (mailto:, tel:, etc.) via the browser.
 * Use this instead of directly assigning window.location.href for non-route URLs.
 */
export function openExternalUrl(url: string): void {
	window.location.href = url;
}

/**
 * Returns the current page origin (protocol + hostname + port).
 * Centralises access to window.location.origin for use in URL construction.
 */
export function getPageOrigin(): string {
	return window.location.origin;
}

/**
 * Performs a full page reload at the current URL.
 * Use this when the app needs to re-initialize from scratch (e.g., critical error recovery).
 */
export function reloadPage(): void {
	window.location.reload();
}
